import React from "react";
import { NavLink } from "react-router-dom";
import "../css/footer.css";

import { ReactComponent as HomeIcon } from "icons/home.svg";
import { ReactComponent as HomeFilledIcon } from "icons/home-filled.svg";
import { ReactComponent as MoreGamesIcon } from "icons/more-games.svg";
import { ReactComponent as MoreGamesFilledIcon } from "icons/more-games-filled.svg";
import { ReactComponent as ChampionshipIcon } from "icons/championship.svg";
import { ReactComponent as ChampionshipFilledIcon } from "icons/championship-filled.svg";
import { ReactComponent as LeaderboardIcon } from "icons/leaderboard.svg";
import { ReactComponent as LeaderboardFilledIcon } from "icons/leaderboard-filled.svg";
import { ReactComponent as ProfileIcon } from "icons/profile.svg";
import { ReactComponent as ProfileFilledIcon } from "icons/profile-filled.svg";

const Footer = () => {
  return (
    <>
      <div className="bottom-spacer" style={{ height: "65px" }}></div>
      <div className="bottom-nav">
        <div className="bottom-nav-bg row gx-0 box-wrapper mx-auto container-fluid d-flex align-content-center">
          <div className="col">
            <div className="nav-box mt-2">
              <NavLink to="/home" exact="true" className="nav-box-ico">
                {({ isActive }) => (isActive ? <HomeFilledIcon /> : <HomeIcon />)}
              </NavLink>
            </div>
          </div>
          <div className="col">
            <div className="nav-box mt-2">
              <NavLink to="/more-games" exact="true" className="nav-box-ico">
                {({ isActive }) => (isActive ? <MoreGamesFilledIcon /> : <MoreGamesIcon />)}
              </NavLink>
            </div>
          </div>
          <div className="col">
            <div className="nav-box mt-3">
              <NavLink to="/championship" className="nav-box-ico">
                {({ isActive }) => (isActive ? <ChampionshipFilledIcon /> : <ChampionshipIcon />)}
              </NavLink>
            </div>
          </div>
          <div className="col">
            <div className="nav-box mt-2">
              <NavLink to="/leaderboard" exact="true" className="nav-box-ico">
                {({ isActive }) => (isActive ? <LeaderboardFilledIcon /> : <LeaderboardIcon />)}
              </NavLink>
            </div>
          </div>
          <div className="col">
            <div className="nav-box mt-2">
              <NavLink to="/profile" className="nav-box-ico">
                {({ isActive }) => (isActive ? <ProfileFilledIcon /> : <ProfileIcon />)}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
